/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/member-ordering */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CallState } from '@lcs/shared/api';
import { ExtensionGroupInput, ExtensionTypes } from 'generated/graphql-types';
import { Subject } from 'rxjs';
import { DetailView } from 'src/app/common-components/detail/detail-view';
import { ExtensionGroupDetailSaveEvent } from '../models/extension-group-detail-form-submit-event';
import { ExtensionGroupDetailView } from '../models/extension-group-detail-view.model';
import { ExtensionGroupPrivileges } from '../models/extension-group-privileges';
import { ExtensionGroupDetailFormService } from '../services/extension-group-detail-form.service';
@Component({
   changeDetection: ChangeDetectionStrategy.OnPush,
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-extension-group-detail-view',
   styleUrls: ['./extension-group-detail-view.component.scss'],
   templateUrl: './extension-group-detail-view.component.html',
   standalone: false,
})
export class ExtensionGroupDetailViewComponent extends DetailView {
   @Input() get extensionGroup(): ExtensionGroupDetailView | null {
      return this._extensionGroup;
   }

   set extensionGroup(value: ExtensionGroupDetailView | null) {
      this._extensionGroup = value;
      if (value) {
         this.formService.updateExtensionGroup(value);
      }
   }

   @Input() set extensionGroupPrivileges(privileges: ExtensionGroupPrivileges) {
      this._extensionGroupPrivileges = privileges;
      if (!privileges?.canEdit) {
         this.form.disable();
      } else if (privileges.canEdit) {
         this._canEditButton = true;
         this.form.enable();
      }
   }

   get extensionGroupPrivileges(): ExtensionGroupPrivileges {
      return this._extensionGroupPrivileges;
   }

   @Input() callState: CallState;

   @Input() accountId: number | null;

   @Output() formSaveCanceled = new EventEmitter<void>();

   @Output() formSubmitted = new EventEmitter<ExtensionGroupDetailSaveEvent>();

   @Output() deleteExtensionGroup = new EventEmitter<{
      extensionGroupId: number;
   }>();

   form: UntypedFormGroup;

   private _extensionGroup: ExtensionGroupDetailView | null;

   private _extensionGroupPrivileges: ExtensionGroupPrivileges;

   private _canEditButton: boolean = false;

   private destroyed$ = new Subject<void>();

   extensionGroupMemberTypes = [ExtensionTypes.Phone];

   searchControl = new UntypedFormControl('');

   callLogsLoaded: boolean = false;

   callLogsTabLabel = 'Call Log';

   constructor(public formService: ExtensionGroupDetailFormService) {
      super();
      this.form = this.formService.form;
   }

   onSubmit(): void {
      const submitEvent = this.getFormSubmittedEvent();
      if (submitEvent) {
         this.formSubmitted.emit(submitEvent);
      }
   }

   onCancel(): void {
      this.formSaveCanceled.emit();
   }

   canDelete(): boolean {
      if (this._extensionGroup?.account?.accountId) {
         return this._extensionGroupPrivileges.canDelete;
      } else {
         return false;
      }
   }
   onDeleteClick(): void {
      if (this.extensionGroup) {
         this.deleteExtensionGroup.emit({
            extensionGroupId: this.extensionGroup.extensionGroupId,
         });
      }
   }

   onTabChange(event: MatTabChangeEvent) {
      if (event.tab.textLabel === this.callLogsTabLabel) {
         this.callLogsLoaded = true;
      }
   }

   emitExtensionGroupExtensionsChange() {
      this.form.controls.extensionGroupExtensions.markAsDirty();
   }
   private getFormSubmittedEvent(): ExtensionGroupDetailSaveEvent | null {
      if (!this.formService.form.dirty || !this.extensionGroup) {
         return null;
      }

      const extensionGroup = this.formService.getValue(this.extensionGroup.extensionGroupId);
      let extensionGroupFields: (keyof ExtensionGroupInput)[] = [];
      extensionGroupFields = this.formService.addFieldForDirtyControl(extensionGroupFields, 'account', 'accountId');
      extensionGroupFields = this.formService.addFieldForDirtyControl(extensionGroupFields, 'name');
      extensionGroupFields = this.formService.addFieldForDirtyControl(extensionGroupFields, 'description');
      extensionGroupFields = this.formService.addFieldForDirtyControl(extensionGroupFields, 'extensionGroupExtensions');
      return { extensionGroup, extensionGroupFields };
   }
}
